<template>
  <div class="mt-3 crud">
    <div class="crudform">
      <b-button
        block
        class="btn btn-success btn-sm"
        type="button"
        @click="nuevaOferta"
      >
        Nueva Oferta
      </b-button>
    </div>

    <div v-show="mostrarTabla">
      <b-row>
        <b-input-group class="mt-4 mb-3">
          <b-form-input
            v-model="searchText"
            size="sm"
            placeholder="Buscar..."
            class="ml-1 mr-1 mt-1 mb-1"
            @keyup.enter="getOfertas"
          ></b-form-input>
          <b-button
            @click="getOfertas"
            variant="outline-secondary"
            size="sm"
            class="search-button mt-1 mb-2 ml-1 mr-1"
          >
            <i class="fa fa-search"></i>
          </b-button>
          
          <b-pagination
            class="ml-2 mr-2 mt-1 mb-1"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="10"
            aria-controls="tablaOfertas"
            size="sm"
            @change="getOfertas"
          ></b-pagination>
        </b-input-group>
      </b-row>

      <b-row class="mb-3 d-flex align-items-center">
        <b-col md="auto">
          <b-form-checkbox 
            v-model="showNoGanadas" 
            switch 
            @change="getOfertas"
            class="font-weight-bold"
            style="color: #6c757d;">
            No Ganadas
          </b-form-checkbox>
        </b-col>
        <b-col md="auto" class="ml-4">
          <b-form-checkbox 
            v-model="showGanadas" 
            switch 
            @change="getOfertas"
            class="font-weight-bold"
            style="color: #6c757d;">
            Ganadas
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-table
        style="font-size: 90%"
        responsive
        id="tablaOfertas"
        :busy="busy"
        :fields="fields"
        :items="ofertas"
        small
        hover
        primary-key="id"
      >
        <template #cell(lock)="{ item }">
          <i v-if="item.editandoProject" class="fas fa-lock text-danger" v-b-tooltip.hover
             :title="'Editando por ' + item.empleadoEditando"></i>
          <i v-else class="fas fa-lock-open text-success" v-b-tooltip.hover title="Libre para editar"></i>
        </template>

        <template #cell(cliente)="row">
          {{ row.item.cliente ? row.item.cliente.nombre : '-' }}
        </template>
        
        <template #cell(importeTotal)="row">
          <span class="font-weight-bold">
            {{ getImporteTotal(row.item) | currency }}
          </span>
        </template>

        <template #cell(accion)="row">
          <b-button-group size="sm">
            <b-button
              size="sm"
              variant="outline-success"
              @click="editarOferta(row.item)"
              class="mr-1"
            >
              <i class="fas fa-edit"></i>
            </b-button>
            <b-button
              size="sm"
              variant="outline-info"
              @click="openChat(row.item)"
              class="mr-1"
              v-b-tooltip.hover.top
              title="Chat de la Oferta"
            >
              <i class="fas fa-comments"></i>
            </b-button>
            <b-button
              size="sm"
              variant="outline-danger"
              @click="eliminarOferta(row.item)"
              v-if="isSuperAdmin"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </b-button-group>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </div>

    <!-- Modal Chat Oferta -->
    <b-modal
      id="modal-chat-oferta-list"
      size="xl"
      hide-header
      ok-only
      ok-title="Cerrar Chat"
    >
      <chat-oferta
        v-if="selectedOferta"
        :oferta-id="String(selectedOferta.id)"
        :codigo="selectedOferta.numeroOferta"
        :username="currentUserName"
      />
    </b-modal>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";
import ChatOferta from "./ChatOferta.vue";

export default {
  name: "OfertasComponent",
  components: {
    ChatOferta
  },
  data() {
    return {
      busy: false,
      mostrarTabla: true,
      searchText: "",
      showGanadas: false,
      showNoGanadas: true,
      totalRows: 0,
      currentPage: 1,
      ofertas: [],
      fields: [
        { key: "lock", label: "", thStyle: { width: "3em", textAlign: "center" }, tdClass: 'align-middle' },
        { key: "numeroOferta", label: "Nº Oferta", sortable: true },
        { key: "nombreOferta", label: "Nombre", sortable: true },
        { key: "cliente", label: "Cliente", sortable: true },
        { key: "contactoOferta", label: "Persona de Contacto", sortable: true },
        { key: "emailContacto", label: "Email contacto", sortable: true },
        { key: "importeTotal", label: "Importe Total", sortable: true },
        { key: "accion", label: "Acciones", thStyle: { width: "100px" } }
      ],
      formOferta: {
        id: null,
        numeroOferta: "",
        nombreOferta: ""
      },
      selectedOferta: null,
      nombreEmpleado: ""
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isSuperAdmin() {
      return this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('ROLE_SUPERADMIN');
    },
    currentUserName() {
      return this.nombreEmpleado || (this.currentUser ? this.currentUser.username : "");
    }
  },
  watch: {
    '$route.query.openChatId': {
      handler: 'handleQueryChat',
      immediate: false
    }
  },
  mounted() {
    this.cargarNombreEmpleado();
    this.getOfertas();
    this.handleQueryChat();
  },
  methods: {
    async getOfertas() {
      this.busy = true;
      const page = this.currentPage - 1;
      try {
        const response = await api1.get("/api/dekra-projects/v204/oferta/paginado", {
          params: {
            page,
            text: this.searchText,
            showGanadas: this.showGanadas,
            showNoGanadas: this.showNoGanadas
          }
        });
        this.ofertas = response.data.content;
        this.totalRows = response.data.totalElements;
      } catch (error) {
        console.error("Error fetching ofertas", error);
      } finally {
        this.busy = false;
      }
    },
    nuevaOferta() {
      this.$router.push({ name: 'detalle-oferta', params: { id: 'nuevo' } });
    },
    editarOferta(item) {
      this.$router.push({ name: 'detalle-oferta', params: { id: item.id } });
    },
    async eliminarOferta(item) {
      if (confirm("¿Estás seguro de eliminar esta oferta?")) {
        try {
          await api1.delete(`/api/dekra-projects/v204/oferta/${item.id}`);
          this.getOfertas();
        } catch (error) {
          console.error("Error deleting oferta", error);
        }
      }
    },
    async cargarNombreEmpleado() {
      try {
        if (!this.currentUser?.username) return;
        const { data } = await api1.get(`/api/dekra/v204/empleado/username/${encodeURIComponent(this.currentUser.username)}`);
        this.nombreEmpleado = data?.nombre || "";
      } catch (error) {
        console.error("Error al obtener el empleado:", error);
      }
    },
    openChat(item) {
      this.selectedOferta = item;
      this.$bvModal.show("modal-chat-oferta-list");
    },
    async handleQueryChat() {
      const openChatId = this.$route.query.openChatId;
      if (openChatId) {
        try {
          const response = await api1.get(`/api/dekra-projects/v204/oferta/${openChatId}`);
          if (response.data) {
            this.openChat(response.data);
          }
        } catch (error) {
          console.error("Error loading offer for chat from query", error);
        }
      }
    },
    getImporteTotal(oferta) {
      if (!oferta.versiones || oferta.versiones.length === 0) return 0;
      // Usar la última versión
      const version = oferta.versiones[oferta.versiones.length - 1];
      if (!version.items || version.items.length === 0) return 0;
      
      let subtotal = 0;
      version.items.forEach(item => {
        if (!item.seleccionado || item.esDescuento || item.opcional) return;
        const baseRedondeada = Math.round((Number(item.importeItem) || 0) / 50) * 50;
        const localDiscountPct = (Number(item.porcentajeDescuento) || 0) / 100;
        const discountedPrice = baseRedondeada * (1 - localDiscountPct);
        subtotal += discountedPrice;
      });

      let total = subtotal;
      version.items.forEach(item => {
        if (!item.seleccionado || !item.esDescuento) return;
        let itemDiscount = subtotal * ((Number(item.porcentajeDescuento) || 0) / 100);
        itemDiscount = Math.round(itemDiscount / 50) * 50;
        total -= itemDiscount;
      });
      
      return Math.round(total * 100) / 100;
    }
  },
  filters: {
    currency(value) {
      if (typeof value !== "number") return value;
      return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value);
    }
  }
};
</script>

<style>
/* Fix for tooltips blocking clicks */
.tooltip {
  pointer-events: none !important;
}
</style>
